<div class="porte-empresa-form-control">
    <label class="col-form-label">
        {{label}}
    </label>
    <div class="input-group">                        
        <div class="input-group-prepend">
            <span class="input-group-text">
                R$
            </span>
        </div>
        <input type="text" class="form-control text-right" [value]="capitalSocial | decimalFormat: 1:2:2" disabled="disabled" readonly="readonly">                                                                                                        
    </div>
    <p class="form-text text-muted">
        {{helpText}}
    </p>    
</div>